// extracted by mini-css-extract-plugin
module.exports = {"root":"FormTimerError_root__yov1j","errorMessage":"FormTimerError_errorMessage__MoR1a","button":"FormTimerError_button__GswI4"};